import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Observable, Subject, Subscription} from 'rxjs';

export interface PopupProgressToastData {
    title?: string;
    subtitle?: string;
    /** Gesamtanzahl. Wenn null/undefined oder 0, wird ein indeterminierter Balken gezeigt. */
    total?: number | null;
    /** Stream mit der aktuell geladenen Anzahl. */
    progress$?: Observable<number>;
    cancelable?: boolean;
    cancelLabel?: string;
}

@Component({
    selector: 'phscw-popup-progress-toast',
    templateUrl: './popup-progress-toast.component.html',
    styleUrls: ['./popup-progress-toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PopupProgressToastComponent implements OnInit, OnDestroy {
    private cdr = inject(ChangeDetectorRef);
    private sub?: Subscription;

    loaded = 0;
    percent = 0;

    constructor(
        public dialogRef: MatDialogRef<PopupProgressToastComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PopupProgressToastData,
    ) {
        dialogRef.disableClose = true;
    }

    get total(): number | null {
        const t = this.data?.total;
        return t != null && t > 0 ? t : null;
    }

    get isDeterminate(): boolean {
        return this.total != null;
    }

    ngOnInit(): void {
        const stream = this.data?.progress$;
        if (!stream) return;
        this.sub = stream.subscribe((loaded) => {
            this.loaded = loaded;
            const total = this.total;
            if (total != null) {
                const p = Math.floor((loaded / total) * 100);
                this.percent = Math.min(100, Math.max(0, p));
            }
            this.cdr.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    onCancel(): void {
        this.dialogRef.close('cancelled');
    }
}
